import React, { useCallback, useMemo } from 'react';
import classnames from 'classnames';
import { TableV2 } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { tableStateReducer, useTable } from "./hooks/index.js";
import S from './TableView.css';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.table.TableView');
export default function TableView(props) {
  const {
    total,
    pageItems,
    variant,
    rollover,
    selection,
    targeted,
    delegate,
    afterHooks,
    onUpdateFilterModel,
    paginate = false,
    context,
    path,
    noDataMessage = t('noData'),
    overrides,
    dataViewerId,
    filters,
    onFilterChange
  } = props;
  const {
    columns,
    gridRef
  } = useTable({
    ...props,
    total,
    pageItems,
    onUpdateFilterModel,
    context,
    path
  });
  const fData = useMemo(() => {
    return pageItems.filter(item => item != null);
  }, [pageItems]);
  const stateReducer = useCallback((newState, action, prevState) => {
    return tableStateReducer(newState, action, prevState, {
      overrides,
      dataViewerId
    });
  }, [dataViewerId, overrides]);
  const tableInstanceProps = useMemo(() => {
    return {
      stateReducer,
      rollover,
      selection,
      targeted,
      delegate,
      context,
      filters,
      onFilterChange
    };
  }, [stateReducer, rollover, selection, targeted, delegate, context, filters, onFilterChange]);
  const bodyClassName = fData?.length ? null : classnames(S.fill, S.win);
  return /*#__PURE__*/_jsx(TableV2, {
    type: "virtualized",
    bodyRef: gridRef,
    bodyClassName: bodyClassName,
    noDataMessage: noDataMessage,
    className: S.table,
    variant: variant,
    data: fData,
    columns: columns,
    afterHooks: afterHooks,
    paginate: paginate,
    tableInstanceProps: tableInstanceProps,
    sortable: false
  });
}